const translations = {
  newTab: 'New tab',
  filter: 'Filter',
  addWidget: 'Add Widget',
  closeEdit: 'Close edition',
  welcome: 'Welcome, {{name}}!',
  welcomeMessage: 'See what we have prepared for you today.',
  dashboardTitle: 'Dashboard',
  'defaultTabs.productivity': 'Productivity',
  'defaultTabs.ranking': 'Ranking',
  'defaultTabs.efficiency': 'Efficiency',
  'defaultTabs.volumeByStatus': 'Volume of activities by status',
  'removeScreen.confirm': 'Are you sure you want to remove?',
  'removeScreen.success': 'Screen removed successfully!',
  'removeScreen.error': 'An error occurred while removing!'
}

export default translations
